var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex flex-column fill-height overflow-y-auto",
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "100%"
    }
  }, [_vm.filteredJobs.length ? _c('v-virtual-scroll', {
    staticClass: "mt-4",
    attrs: {
      "items": _vm.filteredJobs,
      "item-height": "84",
      "bench": "10"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('JobBlock', {
          attrs: {
            "job": item
          },
          on: {
            "prioritiseIntent": _vm.prioritiseIntent,
            "rightClick": function rightClick(e) {
              return _vm.$emit('rightClick', {
                job: item,
                e: e
              });
            }
          }
        })];
      }
    }], null, false, 3758866860)
  }) : _c('p', [_c('NoPrioritiesBlock', {
    on: {
      "prioritiseIntent": _vm.prioritiseIntent
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }